import type { U3142AutoCompletCriterias } from '../U3142Service';

const NBSP = '\u00a0';

/**
 * Retire les espaces (y compris insécables) pour comparer / rechercher un numéro de lot.
 * Aligné backend `REPLACE(ld.lot, ' ', '')` + saisie utilisateur « 1 049 370 » ou « 1049370 ».
 */
export function u3142CompactLotForSearch(raw: string): string {
  return raw.replaceAll(NBSP, ' ').replace(/\s+/g, '');
}

/** Critères autocomplete findSearchLots : compacte le champ `lot` avant POST. */
export function u3142MapFindSearchLotsCriterias(criterias: U3142AutoCompletCriterias): U3142AutoCompletCriterias {
  return criterias.map((c) => {
    if (c.fieldName !== 'lot' || typeof c.value !== 'string') {
      return c;
    }
    const trimmed = c.value.trim();
    if (!trimmed) {
      return c;
    }
    return { ...c, value: u3142CompactLotForSearch(trimmed) };
  });
}
